// extracted by mini-css-extract-plugin
export default {"cls1":"Menu-cls1___1f6d60f0492b8bb7465","cls2":"Menu-cls2__bfc8b1727f042fe6f261 Menu-cls1___1f6d60f0492b8bb7465"};